export default "__VITE_ASSET__nHNtz2$p__"